import { Component, OnInit, ViewChild, AfterContentInit } from '@angular/core';
import { OrderBatchLogisticsWizardService } from '../../../../services/wizard/logistic/order-batch-send-wizard.service';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { Router, ActivatedRoute } from '@angular/router';
import { WizardStep } from '../../../../wizard/wizard.component';
import { MatTabGroup } from '@angular/material/tabs';
// tslint:disable-next-line:max-line-length
import { SendStudyReportLogisticsDetailComponent } from '../send-study-report-logistics-detail/send-study-report-logistics-detail.component';
import { StudyReportSendWizardService } from 'src/app/services/wizard/logistic/study-report-send-wizard';
import { SendStudyReportLogisticsItemComponent } from '../send-study-report-logistics-item/send-study-report-logistics-item.component';
// tslint:disable-next-line:max-line-length
import { ReceiveStudyReportLogisticsItemComponent } from '../receive-study-report-logistics-item/receive-study-report-logistics-item.component';
import { ConfirmDialogService } from '../../../../services/confirm-dialog.service';


@Component({
    selector: 'app-receive-study-report-logistics-wizard',
    templateUrl: './receive-study-report-logistics-wizard.component.html',
    providers: [{ provide: StudyReportSendWizardService, useClass: StudyReportSendWizardService }]
  })

  export class ReceiveStudyReportLogisticsWizardComponent implements OnInit, AfterContentInit {
    loadingAction: boolean;
    loading: boolean;
    @ViewChild('tabGroup', {static: false}) tabGroup: MatTabGroup;
    @ViewChild('sendStudyReportLogisticsDetail', {static: false}) sendStudyReportLogisticsDetail: SendStudyReportLogisticsDetailComponent;
    @ViewChild('receiveStudyReportLogisticsItem', {static: false}) receiveStudyReportLogisticsItem: ReceiveStudyReportLogisticsItemComponent;


    constructor(private notificationToastService: NotificationToastService
      , private studyReportSendWizardService: StudyReportSendWizardService
      , public router: Router
      , private confirmDialogService: ConfirmDialogService
      , private route: ActivatedRoute)  {
    }

    ngOnInit(): void {
      this.loading = true;
      this.route.params.subscribe(async (params) => {
        try {
          const studyReportBatchId = params['Id'] ? params['Id'] : null;
          await this.studyReportSendWizardService.initialize(studyReportBatchId, true);
          setTimeout(() => {
            this.sendStudyReportLogisticsDetail.activate();
          }, 0);
        } catch (err) {
          this.notificationToastService.error(JSON.stringify(err), 'Recepción de informes');
        } finally {
          this.loading = false;
        }
      });
    }

    cancel(): void {
      history.back();
    }

    async receive() {
      if (!this.validateSteps(this.getSteps().length - 1)) {
       this.confirmDialogService.confirm('Recepción de informes'
        , '¿Está seguro de recibir los informes ingresados? Los informes no seleccionadas pasarán a estado "No recibido".'
        , 'Sí', 'No' ).subscribe(async (value) => {
          if (value) {
            try {
              this.loadingAction = true;
              if (await this.studyReportSendWizardService.studyReportBatchReceive()) {
                this.cancel();
              }
            } catch (err) {
              this.notificationToastService.error(JSON.stringify(err), 'Recepción de informes');
            } finally {
              this.loadingAction = false;
            }
          }
        });
      }
    }

    ngAfterContentInit(): void {

    }

    selectedIndexChange(newIndex: number): void {
      this.validateSteps(newIndex);
      const steps = this.getSteps();
      if (steps.length > newIndex) {
        steps[newIndex].activate();
      }
    }

    private validateSteps(newIndex: number): boolean {
      const steps = this.getSteps();
      let inx = 0;
      let hasError = false;
      while (inx <= newIndex && steps.length > inx && !hasError) {
        hasError = !steps[inx].completed;
        if (!hasError) {
          steps[inx].save();
        }
        inx = inx + 1;
      }
      if (hasError) {
        this.tabGroup.selectedIndex = inx - 1;
      }
      return hasError;
    }

    private getSteps() {
      const steps: WizardStep[] = [];
      // se tienen que agregar los pasos en el mismo orden que aparecen
      if (this.sendStudyReportLogisticsDetail
        && this.sendStudyReportLogisticsDetail.isInit) {
        steps.push(this.sendStudyReportLogisticsDetail);
      }

      if (this.receiveStudyReportLogisticsItem
        && this.receiveStudyReportLogisticsItem.isInit) {
        steps.push(this.receiveStudyReportLogisticsItem);
      }

      return steps;
    }
}
